import { DaylightCommonContent } from "../../../../modules/content/components/DaylightCommonContent/DaylightCommonContent";
import { DaylightMedia } from "../../../../modules/content/components/DaylightMedia/DaylightMedia";
import { DaylightSection } from "../../../../modules/content/components/DaylightSection/DaylightSection";
import type { IImageBlockProps } from "./ImageBlock.props";

export const ImageBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  eyebrow,
  heading,
  headingEffect,
  image,
  parentClass,
  spacing,
}: IImageBlockProps) => {
  if (!image) return null;

  return (
    <DaylightSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-8 md:gap-12">
        <DaylightCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
          headingEffect={headingEffect}
          reveal
        />
        <div
          className="daylight-work-surface rounded-[28px] p-3 md:p-5"
          data-reveal="stagger"
          data-reveal-enter="focus"
        >
          <DaylightMedia
            aspectRatio={image.aspectRatio || "16:9"}
            media={image.image}
            effect={image.effect}
            sizes="(min-width: 1280px) 1184px, calc(100vw - 48px)"
          />
        </div>
      </div>
    </DaylightSection>
  );
};

ImageBlock.displayName = "Block::ImageBlock";
